import React, { useState } from 'react';
import './LearningResources.css';

const LearningResources = () => {
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);

  const pastPapers = {
    ICSE: {
      '10th': {
        'Practice Prelims Paper': ['#'],
        'Past School Papers': ['#']
      },
      '9th': {
        'Practice Prelims Paper': ['#'],
        'Past School Papers': ['#']
      },
      '8th': {
        'Practice Prelims Paper': ['#'],
        'Past School Papers': ['#']
      }
    },
    CBSE: {
      '10th': {
        'Practice Prelims Paper': ['#'],
        'Past School Papers': ['#']
      },
      '9th': {
        'Practice Prelims Paper': ['#'],
        'Past School Papers': ['#']
      }
    }
  };

  const videoLectures = [
    {
      title: "Mathematics Class X",
      url: "https://youtube.com/@biyanissuper30eportal"
    },
    {
      title: "Physics Class X",
      url: "https://youtube.com/@biyanissuper30eportal"
    },
    {
      title: "Chemistry Class X",
      url: "https://youtube.com/@biyanissuper30eportal"
    }
  ];

  const handleBoardSelect = (board) => {
    setSelectedBoard(board === selectedBoard ? null : board);
    setSelectedClass(null);
  };

  const handleClassSelect = (className) => {
    setSelectedClass(className === selectedClass ? null : className);
  };

  const renderPaperLinks = (paperTypes) => (
    <div className="paper-types-container">
      {Object.entries(paperTypes).map(([type, links]) => (
        <div key={type} className="paper-type-card">
          <h4 className="paper-type-title">{type}</h4>
          <div className="paper-links">
            {links.map((link, index) => (
              <a
                key={index}
                href={link}
                className="resource-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="learning-resources-bg">
      <svg className="learning-resources-bg-svg" height="80" viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#204d7d" fillOpacity="0.08" d="M0,80 C480,0 960,160 1440,80 L1440,0 L0,0 Z"></path>
      </svg>
      <div className="learning-resources">
        <div className="resources-container fade-in">
          <h1 className="resources-title">Learning Resources</h1>
          
          <section className="resources-section">
            <h2 className="section-title">Past Papers</h2>
            
            <div className="selection-container">
              <div className="board-selection">
                <h3 className="selection-subtitle">Select Board</h3>
                <div className="selection-options">
                  {Object.keys(pastPapers).map((board) => (
                    <button
                      key={board}
                      className={`selection-button ${selectedBoard === board ? 'active' : ''}`}
                      onClick={() => handleBoardSelect(board)}
                    >
                      {board}
                    </button>
                  ))}
                </div>
              </div>

              {selectedBoard && (
                <div className="class-selection">
                  <h3 className="selection-subtitle">Select Class</h3>
                  <div className="selection-options">
                    {Object.keys(pastPapers[selectedBoard]).map((className) => (
                      <button
                        key={className}
                        className={`selection-button ${selectedClass === className ? 'active' : ''}`}
                        onClick={() => handleClassSelect(className)}
                      >
                        Class {className}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {selectedBoard && selectedClass && (
                <div className="papers-section">
                  <h3 className="selection-subtitle">Available Papers</h3>
                  {renderPaperLinks(pastPapers[selectedBoard][selectedClass])}
                </div>
              )}
            </div>
          </section>

          <section className="resources-section">
            <h2 className="section-title">Video Lectures</h2>
            <div className="video-lectures-grid">
              {videoLectures.map((lecture, index) => (
                <div key={index} className="video-lecture-card">
                  <h3 className="lecture-title">{lecture.title}</h3>
                  <a
                    href={lecture.url}
                    className="resource-link video-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Watch on YouTube
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LearningResources; 